export enum CartAction {
  ClearCart = 'clearCart',
  DeleteItem = 'deleteItem',
  RefreshCart = 'refreshCart',
}
